// Roman numerals for the chart's historical reading (R548).
//
// The historical reading writes a figure the way an engraved chart writes
// it: the depth of an isobath, the hour of a siege window, the count of a
// ring. One function owns the conversion, so a piece never carries a table
// of its own.

/** The value/letter table, largest first. It is the whole algorithm. */
const TABLE: readonly (readonly [number, string])[] = [
  [1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'],
  [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'],
  [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I'],
];

/**
 * `n` in Roman numerals, for 1 to 3999.
 *
 * A value outside that range answers the empty string: the numeral system
 * has no zero and no sign, and 4000 needs a bar the atlas does not bake. A
 * caller that can hold such a figure must write the Arabic form instead.
 * A fractional value is truncated toward zero first.
 */
export function toRoman(n: number): string {
  if (!Number.isFinite(n)) return '';
  let v = Math.trunc(n);
  if (v < 1 || v > 3999) return '';
  let out = '';
  for (const [value, letters] of TABLE) {
    while (v >= value) {
      out += letters;
      v -= value;
    }
  }
  return out;
}
